var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5323;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M11.14,2.34a7.63,7.63,0,0,1-4.43-2,1,1,0,0,0-1.42,0A7.63,7.63,0,0,1,.86,2.34a1,1,0,0,0-.86,1c0,.26.06,6.37,5.63,8.6a1,1,0,0,0,.74,0C11.94,9.7,12,3.59,12,3.33A1,1,0,0,0,11.14,2.34Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.95 8.96 6 7.93 4.05 8.96 4.42 6.79 2.85 5.25 5.03 4.93 6 2.96 6.97 4.93 9.15 5.25 7.58 6.79 7.95 8.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldStar);
export default __webpack_public_path__ + "static/media/shield_star.d851225606d86065a2fca3f0b5ef0fad.svg";
export { ForwardRef as ReactComponent };